import * as React from "react";
import Logo from "../logo/logo.png";

function LogoComponent(props) {
  return (
    <img src={Logo} alt="Logo" width={80} height={60} {...props} />
  );
}

export default LogoComponent;

